export default __webpack_public_path__ + "static/media/Chained Wrath.7c0ab584.png";